import { ActionType, BaseActionWidget, ReloadViewActionWidget, SPI, ViewType } from '@kunlun/dependencies';
import CoefficientConfigDialog from './CoefficientConfigDialog.vue';

/**
 * 在授信评审信息列表工具栏渲染「系数配置」按钮，点击弹出系数配置表格
 */
@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.Client,
    model: 'deli.aries.platform.fund.banks.DeliAriesPlatformCreditReviewProxy',
    name: '$$internal_ReloadData',
    widget: 'ClientAction'
  })
)
export class CoefficientConfigActionWidget extends ReloadViewActionWidget {
  initialize(props: any) {
    super.initialize(props);
    this.setComponent(CoefficientConfigDialog);
    return this;
  }
}
